module.exports = __webpack_public_path__ + "static/img/floor-map-check.c836caf.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgV2/floor-map-check.png
// module id = Jh/M
// module chunks = 1